import {applyDefaultProps, PixiComponent} from '@inlet/react-pixi';
import {RichText as DisplayRichText, RichTextOptions} from '@gongxigames/framework/core/fragments/display';
import {CoreDI} from '@gongxigames/framework/core/configs';
import {ObjectBuilder} from '@gongxigames/framework/core/services/ObjectBuilder';
import {inversifyContainer} from '@gongxigames/framework/core/installer';

type RichTextPropTypes = RichTextOptions & {
    x?: number;
    y?: number;
    position?: {x: number; y: number;};
    anchor?: {x: number; y: number;};
    scale?: {x: number; y: number;};
    alpha?: number;
};

export const RichText = PixiComponent<RichTextPropTypes, DisplayRichText>('RichText', {
    create(props: RichTextPropTypes): DisplayRichText {
        const BUILDER = inversifyContainer.get<ObjectBuilder>(CoreDI.ObjectBuilder);

        const text = BUILDER.buildRichText(props);

        return text;
    },

    applyProps(instance: DisplayRichText, oldProps: RichTextPropTypes, newProps: RichTextPropTypes): void {
        applyDefaultProps(instance, oldProps, newProps);

        instance.updateText(newProps);

        const {x, y} = instance.position;
        const position = newProps.position || {x: newProps.x || x, y: newProps.y || y};
        const anchor = newProps.anchor;

        instance.position.set(position.x, position.y);

        if (anchor) {
            const bounds = instance.getLocalBounds();

            instance.pivot.x = bounds.width * anchor.x;
            instance.pivot.y = bounds.height * anchor.y;
        }
    }
});
